/* eslint-disable import/no-anonymous-default-export */
export default (regulator = [], action) => {
  switch (action.type) {
    case "GET_ALL_REGULATORS":
      return action.payload;
    case "CREATE_REGULATOR":
      return [...regulator, action.payload];
    case "DELETE_REGULATOR":
      return regulator.filter((data) => data._id !== action.payload);
    default:
      return regulator;
  }
};
